import React from 'react'
import cx from 'classnames'

import { Cart } from 'src/components/cart'
import { useStore, useToggleCart} from 'src/context/siteContext'

import {
  Close
} from 'src/components/svgs'

export const CartDrawer = () => {
  const { cartIsOpen } = useStore()
  const toggleCart = useToggleCart()
  const trap = cartIsOpen ? (
    <React.Fragment>
      <div className='cart__drawer-inner bcb cw'>
        <div className='ac rel cart__drawer-header py1 rel'>
          <span className='s1'>Your Cart</span>
          <button type='reset' className='p05 abs no-style cart__drawer-close close left top cw' onClick={() => toggleCart()}>
            <Close className='block' />
          </button>
        </div>
        <Cart />
      </div>
    </React.Fragment>
  ) : (
    false
  )
  return (
    <React.Fragment>
      <div
        className={cx('cart__drawer bcw z10 right top x fix', cartIsOpen && 'is-open')}
        id='container'
      >
        {trap}
      </div>
      <div onClick={toggleCart} className={cx('cart__drawer-overlay fix z9 top x left y', cartIsOpen && 'is-open')} />
    </React.Fragment>
  )
}